// ─────────────────────────────────────────────────────────────────────────
// 쓰기 잠금 — 운영사가 기관 콘솔을 **열람**할 때 그 기관 데이터를 건드리지 않게.
//
// [왜 화면이 아니라 여기인가] Firestore 규칙은 이미 platform(운영사) 에게
//   classes·seats·messages·agentActions 의 쓰기를 열어 두었다(운영사 uid 가 모든
//   기관의 adminUserIds 에 들어 있다). 그래서 "버튼을 안 그린다"는 방어가 아니다 —
//   등대의 스캔·계획 실행처럼 화면을 안 거치는 경로가 있고, 그쪽이 조용히 성공하면
//   담당자는 자기가 하지 않은 제안이 결재함에 쌓인 것을 보게 된다.
//   대외로 나가는 조작은 **데이터 계층에서** 막는다(규칙 2).
//
// [왜 모듈 상태인가] 잠금은 "지금 이 탭이 어떤 화면을 열고 있나" 하나뿐이다.
//   콘솔은 한 라우트 트리라 동시에 두 스코프가 열리지 않는다. 쓰기 함수마다 스코프를
//   인자로 받게 하면 서명이 전부 바뀌고, 한 곳만 빠뜨려도 그게 구멍이 된다.
//
// [무회귀] 기본은 잠금 없음. 기관 콘솔(/admin)은 이 모듈을 켜지 않으므로 예전 그대로다.
//
// [열어 두는 것] institutions/{id} 문서 자체(계약·좌석수·서비스 구성)는 원래 운영사의
//   일이라 잠그지 않는다. 잠그는 것은 "담당자 대신 하는 조작" — 반·좌석·메시지·결재.
//   좌석에 복사된 **서비스 구성 사본**(seats.serviceConfig)도 같은 이유로 연다 — 기관 구성을
//   진행 중인 반에 반영하는 것(firestore.applySeatServiceConfig)은 계약의 일이지 담당자 대행이 아니다.
//   그 함수는 serviceConfig 한 필드만 쓰고 AI 경로에서 부를 수 없다([E10] 이 잠근다).
// ─────────────────────────────────────────────────────────────────────────

let lock = null; // { reason: string } | null

/** 열람 모드 진입 — 이유는 사람이 읽을 문장으로. */
export function lockConsoleWrites(reason) {
  lock = { reason: reason || '지금 화면은 열람 전용입니다.' };
}

/** 대행 모드 진입 또는 화면 이탈. */
export function unlockConsoleWrites() {
  lock = null;
}

export function isConsoleWriteLocked() {
  return lock !== null;
}

export function consoleWriteLockReason() {
  return lock ? lock.reason : null;
}

/**
 * 쓰기 직전에 부른다. 잠겨 있으면 던진다 — 조용히 넘어가지 않는다.
 * 호출부는 대부분 이 에러를 그대로 alert 로 띄운다(보이는 실패).
 */
export function assertConsoleWritable() {
  if (!lock) return;
  const err = new Error(lock.reason);
  err.code = 'console/read-only';
  throw err;
}
